<template>
  <div class="cb-header__wrap cb-transition__slide" id="cb-header-wrap" ref="parent" role="banner">
    <div class="cb-header__logo" v-if="logo">
      <img class="cb-header__image" :src="logo" alt="logo">
    </div>
    <!-- check with vivek -->
    <cb-slide-n-fade>
		<div class="cb-header__title" :style="themeColor" v-if="this.$route.meta.headerTitle && this.$route.meta.nonLoggedInUser" :class="{'cb-header__title--xl': !logo}" id="cb-header-title">
		  {{ nlt(this.$route.meta.headerTitle) }}
		</div>
		<div v-else class="cb-header__title" :style="themeColor" :class="{'cb-header__title--xl': !logo}" id="cb-header-title">
			{{ loggedInTitle }}
		</div>
	</cb-slide-n-fade>
    <edit-subscription-add-menu v-if="$route.name === 'edit_subscription'"></edit-subscription-add-menu>
  </div>
</template>
<script type="text/javascript">
import EditSubscriptionAddMenu from "@/components/collections/headers/EditSubscriptionAddMenu"

export default {
	components: {
		"edit-subscription-add-menu": EditSubscriptionAddMenu
	},
	computed: {
		loggedInTitle() {
			const key = this.$route.meta.headerTitle;
			const text = this.$route.meta.commonTranslate ? this.cmt(key) : this.t(key);
			return text || this.$route.meta.headerTitleFallback || "";
		}
	}
}
</script>
